import $ from './jquery-2.2.0';

/* -- Function Polyfills  */
Number.isNaN = Number.isNaN || function (value) {
    return value !== value;
};

if (!Number.prototype.toMaxPrecision) {
    Object.defineProperty(Number.prototype, 'toMaxPrecision', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function (precision) {
            var value = this.toFixed(precision);
            var decimalIndex = value.indexOf(".");
            if (decimalIndex >= 0) {
                for (var i = value.length - 1; i > decimalIndex; i--) {
                    if (value[i] === "0") {
                        value = value.substring(0, i);
                    } else { break; }
                }
            }

            //if the last character is a decimal, remove it
            if (value[value.length - 1] === ".") {
                value = value.substring(0, value.length - 1);
            }

            return value;
        }
    });
}

//https://stackoverflow.com/questions/3387427/remove-element-by-id/18120786#18120786
if (!Element.prototype.remove) {
    Object.defineProperty(Element.prototype, 'remove', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function () {
            this.parentElement.removeChild(this);
        }
    });
    Object.defineProperty(NodeList.prototype, 'remove', HTMLCollection.prototype.remove = {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function () {
            for (var i = this.length - 1; i >= 0; i--) {
                if (this[i] && this[i].parentElement) {
                    this[i].parentElement.removeChild(this[i]);
                }
            }
        }
    });
    Object.defineProperty(HTMLCollection.prototype, 'remove', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function () {
            for (var i = this.length - 1; i >= 0; i--) {
                if (this[i] && this[i].parentElement) {
                    this[i].parentElement.removeChild(this[i]);
                }
            }
        }
    });
}

if (!Array.prototype.indexOf) {
    Object.defineProperty(Array.prototype, 'indexOf', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function (obj, start) {
            for (var i = (start || 0), j = this.length; i < j; i++) {
                if (this[i] === obj) { return i; }
            }
            return -1;
        }
    });
}

if (!Array.prototype.remove) {
    // Array Remove - By John Resig (MIT Licensed)
    Object.defineProperty(Array.prototype, 'remove', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function (from, to) {
            var rest = this.slice((to || from) + 1 || this.length);
            this.length = from < 0 ? this.length + from : from;
            return this.push.apply(this, rest);
        }
    });
}

if (!Array.prototype.hasOwnProperty("removeElement")) {
    Object.defineProperty(Array.prototype, 'removeElement', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function (el) {
            var i = $.inArray(el, this);
            if (i > -1) {
                Array.prototype.splice.call(this, i, 1);
            }
        }
    });
}

if (!Array.prototype.forEach) {
    Object.defineProperty(Array.prototype, 'forEach', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function (fn, scope) {
            "use strict";
            var i, len;
            for (i = 0, len = this.length; i < len; ++i) {
                if (i in this) {
                    fn.call(scope, this[i], i, this);
                }
            }
        }
    });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}

if (typeof Object.create !== "function") {
    Object.create = function (o) {
        function F() { }
        F.prototype = o;
        return new F();
    };
}

if (typeof Object.values !== "function") {
    Object.values = function (obj) {
        var res = [];
        if (obj) {
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    res.push(obj[i]);
                }
            }
        }
        return res;
    };
}

if (typeof String.prototype.endsWith !== "function") {
    Object.defineProperty(String.prototype, 'endsWith', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function (suffix) {
            return this.indexOf(suffix, this.length - suffix.length) !== -1;
        }
    });
}

if (!String.format) {
    String.format = function (format) {
        var args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != "undefined"
                ? args[number]
                : match
                ;
        });
    };
}

if (!String.replaceAll) {
    String.replaceAll = function (find, replace) {
        function escapeRegExp(string) {
            return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        };
        return this.replace(new RegExp(escapeRegExp(find), 'g'), replace);
    };
}

if (!String.prototype.insert) {
    Object.defineProperty(String.prototype, 'insert', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function (index, string) {
            if (index > 0)
                return this.substring(0, index) + string + this.substring(index, this.length);
            else
                return string + this;
        }
    });
}

//https://stackoverflow.com/questions/30867172/code-not-running-in-ie-11-works-fine-in-chrome
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        writable: true,
        enumerable: false,
        configurable: true,
        value: function (searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        },
    });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        },
        configurable: true,
        writable: true
    });
}

//http://stackoverflow.com/questions/210717/using-jquery-to-center-a-div-on-the-screen
$.fn.center = function () {
    this.css("position", "absolute");
    this.css("top",
        Math.max(0,
            (($(window).height() - $(this).outerHeight()) / 2) +
            $(window).scrollTop()) +
        "px");
    this.css("left",
        Math.max(0,
            (($(window).width() - $(this).outerWidth()) / 2) +
            $(window).scrollLeft()) +
        "px");
    return this;
};

//http://stackoverflow.com/questions/5802467/prevent-scrolling-of-parent-element
$.fn.scrollLock = function () { return $(this).on("DOMMouseScroll mousewheel", function (h) { var g = $(this), f = this.scrollTop, d = this.scrollHeight, b = g.height(), i = h.originalEvent.wheelDelta, a = i > 0, c = function () { h.stopPropagation(); h.preventDefault(); h.returnValue = false; return false }; if (g.get(0).scrollHeight > g.get(0).clientHeight) { if (!a && -i > d - b - f) { g.scrollTop(d); return c() } else { if (a && i > f) { g.scrollTop(0); return c() } } } }) }; $.fn.scrollRelease = function () { return $(this).off("DOMMouseScroll mousewheel") };


//http://stackoverflow.com/questions/14866775/detect-document-height-change
function onElementHeightChange(elm, callback) {
    var lastHeight = elm.clientHeight, newHeight;
    (function run() {
        newHeight = elm.clientHeight;
        if (lastHeight != newHeight)
            callback();
        lastHeight = newHeight;

        if (elm.onElementHeightChangeTimer)
            clearTimeout(elm.onElementHeightChangeTimer);

        elm.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
}


//https://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
(function () {
    if (typeof window.CustomEvent === "function") return false; //If not IE

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();


//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
if (!Math.sign) {
    Math.sign = function (x) {
        // If x is NaN, the result is NaN.
        // If x is -0, the result is -0.
        // If x is +0, the result is +0.
        // If x is negative and not -0, the result is -1.
        // If x is positive and not +0, the result is +1.
        return ((x > 0) - (x < 0)) || +x;
        // A more aesthetic pseudo-representation:
        //
        // ( (x > 0) ? 1 : 0 )  // if x is positive, then positive one
        //          +           // else (because you can't be both - and +)
        // ( (x < 0) ? -1 : 0 ) // if x is negative, then negative one
        //         ||           // if x is 0, -0, or NaN, or not a number,
        //         +x           // then the result will be x, (or) if x is
        //                      // not a number, then x converts to number
    };
}


function insertArrayAt(array, index, arrayToInsert) {
    var localArray = RadResponder.clone(array);
    Array.prototype.splice.apply(localArray, [index, 0].concat(arrayToInsert));
    return localArray;
};



//https://github.com/kevlatus/polyfill-array-includes/blob/master/array-includes.js
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {

            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                // c. Increase k by 1.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}